import "./App.css";
import { Route, Routes } from "react-router-dom";
import Layout from "./containers/Layout";
import LandingPage from "./containers/Pages/Home";
import RemovalHome from "./containers/Pages/RemovalHome";
import OffsetHome from "./containers/Pages/OffsetHome";
import MapPageLayout from "./containers/Pages/MapPageLayout";
import RemovalTool from "./containers/Pages/RemovalTool";
import OffsetTool from "./containers/Pages/OffsetTool";
import { Authenticator } from "@aws-amplify/ui-react";
import Signin from "./containers/Pages/Signin";
import Admin from "./containers/Pages/Admin";

function App() {
  return (
    <Authenticator.Provider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<LandingPage />} />
          <Route path="signin" element={<Signin />} />
          <Route path="admin" element={<Admin />} />
          <Route path="removal" element={<RemovalHome />} />
          <Route path="offset" element={<OffsetHome />} />
          <Route path="map" element={<MapPageLayout />}>
            <Route path="removal" element={<RemovalTool />} />
            <Route path="offset" element={<OffsetTool />} />
          </Route>

          {/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit36
                routes for. */}
          <Route path="*" element={<div />} />
        </Route>
      </Routes>
    </Authenticator.Provider>
  );
}

export default App;
